module.exports = __webpack_public_path__ + "static/img/bg.668bdc66.png";